import { Injectable } from '@angular/core';
import { JeevesSalesCartConfigService } from 'gung-standard-jeeves';
import { ListLayoutMultipleComponent, ListLayout } from 'gung-list';
import { ColmecSalesCartListComponent } from '../../components/cart/colmec-sales-cart-list/colmec-sales-cart-list.component';
import { CartRow } from 'gung-standard';

@Injectable({
  providedIn: 'root'
})
export class ColmecSalesCartConfigService extends JeevesSalesCartConfigService {
  getLayouts(): ListLayout<CartRow>[] {
    return [
      {
        getIconClass: () => '',
        getName: () => 'Cart table',
        getListItemComponent: () => ColmecSalesCartListComponent,
        getListLayoutComponent: () => ListLayoutMultipleComponent
      }
    ];
  }
}
